export const componentName = 'SorterRule';
